import { memo, useEffect, useRef } from "react";
import { Flex } from "./flex";
import * as optInputCss from "./otp-input.module.css";
import { TextInput } from "./text-input";

export const OtpInput = memo(function OtpInput({
  values,
  onChange,
  numeric = false,
}: {
  values: Array<string>;
  onChange: (newValues: Array<string>) => void;
  numeric?: boolean;
}) {
  const inputRefs = useRef<
    Array<HTMLInputElement | HTMLTextAreaElement | null>
  >([]);

  useEffect(() => {
    if (values.every((value) => value === "")) {
      inputRefs.current[0]?.focus();
    }
  }, [values, inputRefs.current]);

  return (
    <Flex dir="row" gap="3xl" justify="center">
      {values.map((value, i) => (
        <div className={optInputCss.inputContainer} key={i}>
          <TextInput
            inputMode="numeric"
            maxLength={1}
            onChange={(newValue) => {
              if (numeric && !/^\d*$/.test(newValue)) {
                return;
              }

              const newValues = [...values];
              newValues[i] = newValue;
              onChange(newValues);

              if (
                newValue &&
                i < values.length - 1 &&
                inputRefs.current[i + 1] instanceof HTMLInputElement
              ) {
                inputRefs.current[i + 1]?.focus();
              }
            }}
            onKeyDown={(e) => {
              if (
                (e.key === "Backspace" || e.key === "Delete") &&
                !value &&
                i > 0
              ) {
                inputRefs.current[i - 1]?.focus();
              }
            }}
            onPaste={(e) => {
              e.preventDefault();
              let paste = e.clipboardData
                .getData("text")
                .slice(0, values.length - i);

              if (numeric) {
                paste = paste.replace(/\D/g, "");
              }

              const newValues = [...values];

              paste.split("").forEach((char, index) => {
                newValues[i + index] = char;
              });

              onChange(newValues);

              if (i + paste.length < values.length) {
                inputRefs.current[i + paste.length]?.focus();
              } else {
                inputRefs.current[values.length - 1]?.focus();
              }
            }}
            ref={(el) => (inputRefs.current[i] = el)}
            value={value}
          />
        </div>
      ))}
    </Flex>
  );
});
